import apiClient from './client'

export interface FlightInfo {
  found: true
  airline: string
  flight_number: string
  departure_airport: string
  departure_city: string
  arrival_airport: string
  arrival_city: string
  departure_time: string
  arrival_time: string
  arrival_terminal: string
}

export interface FlightNotFound {
  found: false
  message: string
}

export type FlightLookupResult = FlightInfo | FlightNotFound

export async function lookupFlight(flight: string, date: string): Promise<FlightLookupResult> {
  const { data } = await apiClient.get('/flights/lookup', {
    params: { flight, date },
  })
  return data
}
